class PlaceSettings extends HTMLElement {
  constructor() {
    super();
    this.summaryPriceEl = null;
    this.addToCartBtn = null;
  }

  connectedCallback() {
    this.initializeElements();
    this.setupEventListeners();
  }

  initializeElements() {
    this.summaryPriceEl = this.querySelector(".summaryprice");
    this.addToCartBtn = this.querySelector(".placeaddtocart .btn");
  }

  setupEventListeners() {
    // Guest selection
    this.querySelectorAll(".gsitem").forEach((item) => {
      item.addEventListener("click", this.handleGuestSelection.bind(this));
    });

    // Quantity changes
    this.querySelectorAll(".js-qty__num").forEach((input) => {
      input.addEventListener("change", this.updateTotalPrice.bind(this));
    });

    // Quantity adjust buttons
    this.querySelectorAll(".js-qty__adjust").forEach((button) => {
      button.addEventListener("click", this.handleQuantityAdjust.bind(this));
    });

    // Add to cart
    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener(
        "click",
        this.handleAddToCart.bind(this)
      );
    }
  }

  handleGuestSelection(event) {
    const target = event.currentTarget;
    this.querySelectorAll(".gsitem").forEach((item) =>
      item.classList.remove("selected")
    );
    target.classList.add("selected");
    this.updateQuantitiesAndPrice();
  }

  updateQuantitiesAndPrice() {
    const guests = parseInt(
      this.querySelector(".gsitem.selected").dataset.guests
    );
    const multiplier = guests / 8;
    let newCost = 0;

    this.querySelectorAll(".quancontrol").forEach((control) => {
      const per8 = parseInt(control.dataset.per8);
      const singleOnly = control.dataset.singleonly === "true";
      const price = parseInt(control.dataset.cost);
      const input = control.querySelector(".js-qty__num");

      let quantity = singleOnly ? per8 : per8 * multiplier;
      input.value = Math.round(quantity);

      newCost += price * quantity;
    });

    this.summaryPriceEl.textContent = theme.Currency.formatMoney(newCost);
  }

  updateTotalPrice() {
    let newCost = 0;

    this.querySelectorAll(".quancontrol").forEach((control) => {
      const price = parseInt(control.dataset.cost);
      const quantity = parseInt(control.querySelector(".js-qty__num").value);
      newCost += price * quantity;
    });

    this.summaryPriceEl.textContent = theme.Currency.formatMoney(newCost);
  }

  handleQuantityAdjust(event) {
    const button = event.currentTarget;
    const input = button.parentElement.querySelector(".js-qty__num");
    const currentValue = parseInt(input.value);

    if (button.classList.contains("js-qty__adjust--plus")) {
      input.value = currentValue + 1;
    } else {
      input.value = Math.max(0, currentValue - 1);
    }

    input.dispatchEvent(new Event("change"));
  }

  async handleAddToCart() {
    this.addToCartBtn.classList.add("btn--loading");

    const items = Array.from(this.querySelectorAll(".quancontrol")).map(
      (control) => {
        const input = control.querySelector(".js-qty__num");
        const id = parseInt(input.id.split("-")[1]);
        return {
          id: id,
          quantity: parseInt(input.value),
        };
      }
    );

    try {
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      document.body.dispatchEvent(new CustomEvent("added.ajaxProduct"));
    } catch (error) {
      console.error("Error adding to cart:", error);
    } finally {
      this.addToCartBtn.classList.remove("btn--loading");
    }
  }
}

customElements.define("place-settings", PlaceSettings);
